import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { arrayOf, shape } from 'prop-types';
import { formatNumberWithoutDecimals } from 'utils/helpers/format';
import * as R from 'ramda';

const MaxProjectionCards = ({ data }) => {
  return (
    <Box
      sx={{
        alignSelf: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gridAutoRows: 'auto',
        gridGap: '24px 16px',
        gridTemplateColumns: 'repeat(auto-fill, 160px)',
        pb: 3,
      }}
    >
      {R.reverse(data).map(({ name, value }) => (
        <Stack key={name} spacing={0.5} sx={{ borderRadius: 0.5, boxShadow: 6, p: 2, width: 160 }}>
          <Typography color="text.primary" variant="caption">
            {name}
          </Typography>
          <Typography variant="caption">{formatNumberWithoutDecimals(value)} bbl</Typography>
        </Stack>
      ))}
    </Box>
  );
};

MaxProjectionCards.propTypes = {
  data: arrayOf(shape({})).isRequired,
};

export default MaxProjectionCards;
